'use client';

import React from 'react';
import styles from './category-second.module.scss';
import { Link } from '@/i18n/navigation';
import IconArrowRightBlue from '@/assets/icons/catalogs/icon-arrow-right-blue.svg';
import { useWindowSize } from 'react-use';
import CategoryCard from '@/components/ui/category-card';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import { useLocale, useTranslations } from 'next-intl';
import {
  OrderDirection,
  ProductVariantSortField,
  useProductVariantsQuery,
} from '@/graphql';
import { useCityStore } from '@/zustand/cityStore';
import { useLanguageCode } from '@/hooks/useLanguageCode';

const SecondContentLiderSellCategory = ({
  categoryId,
}: {
  categoryId: string;
}) => {
  const { width } = useWindowSize();
  const t = useTranslations('Components.category-second-content');
  const { selectedCity } = useCityStore();
  const langaugeCode = useLanguageCode();
  const locale = useLocale();
  const { data, loading } = useProductVariantsQuery({
    variables: {
      first: 4,
      languageCode: langaugeCode,
      city: selectedCity,
      filter: {
        category: categoryId,
      },
      sortBy: {
        field: ProductVariantSortField.ORDER_COUNT,
        direction: OrderDirection.DESC,
      },
    },
    skip: !categoryId,
  });

  const topSellingVariants = data?.productVariants?.edges || [];

  return (
    <div className={styles.liderSellCategory}>
      <div className={styles.header}>
        <h3>{t('sales-liders-in-category')}</h3>
        <Link
          href={`/category/topsellers/${decodeBase64Id(categoryId)}?sort=${
            ProductVariantSortField.POPULARITY
          }`}
          className={styles.link}
        >
          {width <= 600 ? t('all') : t('show-all-products')}{' '}
          <IconArrowRightBlue />
        </Link>
      </div>
      <div className={styles.liderCards}>
        {loading ? (
          <p>Loading...</p>
        ) : (
          topSellingVariants.map(edge => {
            const variant = edge.node;
            return (
              <CategoryCard
                key={variant?.id}
                id={variant?.id}
                slug={variant?.product?.slug}
                productId={variant?.product?.id || ''}
                wide={true}
                image={variant.media?.[0]?.url || ''}
                productType={
                  locale === 'ru'
                    ? variant.product?.category?.name
                    : variant.product?.category?.translation
                      ? variant.product?.category?.translation?.name
                      : variant.product?.category?.name
                }
                title={
                  locale === 'ru' ? variant.name : variant.translation?.name
                }
                pricePerMonth={variant.pricing?.installmentPrice12?.amount || 0}
                price={variant.pricing?.price?.net?.amount || 0}
                discount={variant.pricing?.percentageDiscountAmount || 0}
                priceUndiscounted={
                  variant.pricing?.priceUndiscounted?.net?.amount || 0
                }
                bonus={variant?.pricing?.bonusesAmount}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default SecondContentLiderSellCategory;
